var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg16PxBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M12.5 5.296V5A4.5 4.5 0 0 0 8 .5h0A4.5 4.5 0 0 0 3.5 5v.296A3.981 3.981 0 0 1 1.508 8.75C.867 9.118.5 9.544.5 10c0 1.381 3.358 2.5 7.5 2.5s7.5-1.119 7.5-2.5c0-.456-.367-.882-1.008-1.25A3.98 3.98 0 0 1 12.5 5.296z",
    "data-cap": "butt"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M10.292 14a2.501 2.501 0 0 1-4.584.001",
    "data-cap": "butt",
    "data-color": "color-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16PxBell);
export default __webpack_public_path__ + "static/media/16px_bell.2f51a7a9e2f8319e4eeb29cc2900072f.svg";
export { ForwardRef as ReactComponent };